import React from "react";
import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { CONVERSATIONS_PERMS_ACTIONS } from "../../enums";
import {
    CONVERSATION_LIBRARY_READ_PERMISSION,
    CONVERSATION_PIN_UPDATE_PERMISSION,
    ISSUE_CONVERSATION_DELETE_PERMISSION,
} from "components/dashboard/TrainSAM/SAM/WorkflowSettings/permissions";

const { COPY_CONVERSATION, DELETE_CONVERSATION, PIN_CONVERSATION } =
    CONVERSATIONS_PERMS_ACTIONS;

const ConversationsDropdown = ({
    conversation,
    handleActionModal,
    hasAConversation,
    pinned,
}) => {
    const conversationsDropdownOptions = [
        {
            value: COPY_CONVERSATION,
            label: "Copy Conversation Link",
            baseResources: CONVERSATION_LIBRARY_READ_PERMISSION,
        },
        {
            value: PIN_CONVERSATION,
            label: `${pinned ? "Unpin Conversation" : "Pin Conversation"}`,
            baseResources: CONVERSATION_PIN_UPDATE_PERMISSION,
        },
        {
            value: DELETE_CONVERSATION,
            label: "Delete Conversation",
            baseResources: ISSUE_CONVERSATION_DELETE_PERMISSION,
        },
    ];

    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            noItemMsg='No Conversation Added Yet'
            onChange={({ value }) => handleActionModal(value, conversation)}
            options={hasAConversation ? conversationsDropdownOptions : []}
        />
    );
};

export default ConversationsDropdown;
